import { Avatar, Box, Button, Divider, IconButton, Link, Tooltip, Typography } from "@mui/material";
import { ICliente } from "../../../clientes/interface/ICliente"
import { AvatarBox, ClienteBox, ClientePaperContainer, DadosClienteBox, DividerEndereco, EnderecoBox } from "./styles";
import { IconSquareButton } from "../../../core/components/IconSquareButton";
import { Delete, PersonRemoveOutlined, Person, Restaurant } from "@mui/icons-material";

interface ClientePaperProps {
    cliente: ICliente | undefined;
    removerCliente?: () => void;
    desabilitar?: boolean | undefined;
    ocultar?: boolean | undefined;
    enderecoPaper?: React.ReactNode;
    mesaId?: number;
    onVincularCliente?: () => void;
}

const MAX_TEXT_LENGTH = 22;

const truncateText = (text?: string | null) => {
    if (!text) return '';
    return text.length > MAX_TEXT_LENGTH ? `${text.slice(0, MAX_TEXT_LENGTH)}...` : text;
}

export const ClientePaper = ({ cliente, removerCliente, desabilitar, ocultar, enderecoPaper, mesaId, onVincularCliente }: ClientePaperProps) => {
    const mesaIdValido = mesaId !== undefined && mesaId !== null && !isNaN(Number(mesaId));

    return (
        <ClientePaperContainer elevation={4}>
            {mesaId !== undefined && (
                <Box sx={{ width: '100%' }}>
                    <Box sx={{ width: '100%', display: 'flex', alignItems: 'center', height: '80px' }}>
                        <AvatarBox>
                            <Avatar sx={{ bgcolor: 'grey.200', color: 'text.secondary' }}>
                                {mesaIdValido ? mesaId : <Restaurant sx={{ color: 'text.secondary' }} />}
                            </Avatar>
                        </AvatarBox>
                        <DadosClienteBox>
                            {!mesaIdValido && (
                                <Typography 
                                    sx={{ 
                                        fontFamily: 'Poppins, sans-serif',
                                        color: 'grey.500',
                                        fontSize: 11
                                    }}
                                >
                                    MESA
                                </Typography>
                            )}
                            {mesaIdValido ? (
                                <Typography
                                    variant="body2"
                                    fontWeight={500}
                                >
                                    MESA
                                </Typography>
                            ) : (
                                <Typography variant="body2" fontWeight={500} fontSize={13} color="text.primary">
                                    Indefinido
                                </Typography>
                            )}
                        </DadosClienteBox>
                    </Box>
                    <DividerEndereco />
                </Box>
            )}
            <ClienteBox>
                <AvatarBox>
                    <Avatar sx={{ bgcolor: 'grey.200' }}>
                        <Person sx={{ color: 'text.secondary' }} />
                    </Avatar>
                </AvatarBox>
                <DadosClienteBox>
                    {!cliente && (
                        <Typography 
                            sx={{ 
                                fontFamily: 'Poppins, sans-serif',
                                color: 'grey.500',
                                fontSize: 11
                            }}
                        >
                            CLIENTE
                        </Typography>
                    )}
                    {!cliente ? (
                        onVincularCliente ? (
                            <Link
                                component="button"
                                variant="body2"
                                onClick={onVincularCliente}
                                sx={{
                                    fontWeight: 500,
                                    fontSize: 12,
                                    textDecoration: 'underline',
                                    cursor: 'pointer',
                                    border: 'none',
                                    background: 'none',
                                    padding: 0,
                                    alignSelf: 'flex-start',
                                    textAlign: 'left',
                                    '&:hover': {
                                        textDecoration: 'underline',
                                    }
                                }}
                            >
                                Vincular cliente
                            </Link>
                        ) : (
                            <Typography variant="body2" fontWeight={500} fontSize={13} color="text.primary">Indefinido</Typography>
                        )
                    ) : (
                        <>
                            <Typography
                                variant="body2"
                                fontWeight={500}
                                title={cliente.nome}
                            >
                                {truncateText(cliente.nome)}
                            </Typography>
                            {cliente.telefone ? (
                                <Typography
                                    variant="body2"
                                    color="GrayText"
                                    fontWeight={300}
                                    fontSize={12}
                                >
                                    {cliente.telefone}
                                </Typography>
                            ) : ''}
                        </>
                    )}
                </DadosClienteBox>
                {cliente && !ocultar && (
                    <Tooltip title="Desvincular cliente">
                        <IconButton
                            color="error"
                            onClick={removerCliente}
                            disabled={desabilitar}
                        >
                            <PersonRemoveOutlined sx={{
                                width: "20px",
                                height: "20px",
                            }} />
                        </IconButton>
                    </Tooltip>
                )}
            </ClienteBox>
            {enderecoPaper && (
                <EnderecoBox>
                    <DividerEndereco />
                    {enderecoPaper}
                </EnderecoBox>
            )}
        </ClientePaperContainer>
    );
}